import React from "react";

import PageBanner from "../components/common/PageBanner";
import Contact from "../components/ContactPageComponents/Contact";

import contactBanner from "../assets/about-banner.jpg";

const ContactPage = () => {
  return (
    <>
      <PageBanner title="Contact Us" bgImage={contactBanner} />
      <Contact />
    </>
  );
};

export default ContactPage;
